import script from "./ProjectVideoBadWordList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectVideoBadWordList.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectVideoBadWordList.vue?vue&type=style&index=0&id=761c0e6e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-761c0e6e"]])

export default __exports__